import * as HttpService from "../../../../service/HttpService";

/**  用能概览 -> 运营商服务 **/


const MOCK_ADDRESS = "https://www.fastmock.site/mock/588ccf88c91f9bd2d33c3ef66b76939d/smart";

/**
 * 获取用户规模
 */
export const getUserScale = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewReResource/getEnergyCustCount?pageType="+type);
}

/**
 * 获取管控收益
 */
export const getControlEarning = (type) => {
    return HttpService.get(HttpService.DOMAIN  + "/viewEsMgmt/getEsMgmtStatOrgDiagram?type=" + type);
}
/**
 * 获取用水量
 */
export const getOrgWcons = (type,orgType,id) => {
    return HttpService.get(HttpService.DOMAIN  + "/viewStatisticalPower/getOrgWcons?type=" + type+"&orgType="+orgType+"&ceCustId="+id);
}
/**
 * 获取累计电量
 */
export const getSumPower = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getOrgEconsOfEnergy?type=" + type);
}

/**
 * 获取分项能耗占比
 */
export const getEnergyProportion = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/statCebsdClsEcons/getDeviceEconsProportion?type=" + type);
}

/**
 * 获取负荷特性
 */
export const getLoadInfo = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getEloadOfYmd?type=" + type);
}

/**
 * 获取用能统计信息
 */
export const getStatisticManagement = (type) => {
    return HttpService.get(HttpService.DOMAIN + "/viewEsMgmt/getEsMgmtOutPlanEvent");
}
